const USAGE = {
  BACKEND: 'backEnd',
  FRONTEND: 'frontEnd',
}

module.exports = {
  USAGE,
}